import useFlagCondition from 'components/shared/useFlagCondition'
import { memo } from 'react'
import { useCellVisualizationsSlice } from 'redux/slices/hooks/useCellVisualizationsSlice'
import { PreFilterIntroDialog } from './PreFilterIntroDialog'
import CellSelectionDrawer from './cellSelectionDrawer/CellSelectionDrawer'
import { ColorByDrawer } from './colorBy'
import CellVisualizationsHeader from './header'
import MainGraphContent from './plot/MainGraphContent'
import { MorphotypesToRemove } from './prefilter/MorphotypesToRemove'
import useCellVisualizationUrlParams from './useCellVisualizationUrlParams'
import { PreFilterDisplayImages } from './PreFilterDisplayImages'

export const CellVisualizationScene = memo((): JSX.Element => {
  const { isPreFilter } = useCellVisualizationUrlParams()
  const demoEnabled = useFlagCondition('demoEnabled')
  const {
    cellVisualizations: { groupCompare },
  } = useCellVisualizationsSlice()

  const showPreFilter = isPreFilter && !demoEnabled

  // Collapse (but don't hide) color/filter drawer when drag and drop is enabled
  const dragDropEnabled = groupCompare?.dragDropEnabled ?? false

  return (
    <>
      {showPreFilter && <PreFilterIntroDialog />}
      <CellVisualizationsHeader isPreFilter={showPreFilter} />
      {showPreFilter ? (
        <>
          <ColorByDrawer showPreFilter={showPreFilter} forceCollapsed={dragDropEnabled} />
          <PreFilterDisplayImages />
        </>
      ) : (
        <ColorByDrawer forceCollapsed={dragDropEnabled} />
      )}

      <MainGraphContent />
      {showPreFilter ? <MorphotypesToRemove /> : <CellSelectionDrawer />}
    </>
  )
})

CellVisualizationScene.displayName = 'CellVisualizationScene'

export default CellVisualizationScene
